import React from 'react';
import { Link } from "react-router-dom";
import { FaInstagram, FaLinkedin, FaYoutube } from 'react-icons/fa';
import { FaXTwitter } from "react-icons/fa6";
import logo from '../../assets/logo-2.png';
import { Phone, Mail, MapPin } from "lucide-react";

const Footer = () => {
    return (
        <footer className="bg-white">
            <div className="mx-auto w-full max-w-screen-xl p-4 py-6 lg:py-8">
                <div className="md:flex md:justify-between">
                    <div className="mb-6 md:mb-0">
                        <Link to="/" className="flex items-center">
                            <img src={logo} className="h-40 me-3" alt="The Best Cab Logo" />
                        </Link>
                    </div>
                    <div>
                        <h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase">Contact Details</h2>
                        <ul className="text-gray-500 font-medium space-y-4">
                            <li className="flex items-center gap-2">
                                <Phone className="w-5 h-5 text-gray-500" />
                                <p>
                                    <a href="tel:+917976710874" className="hover:text-pink-600">+91-7976710874</a>,
                                    <a href="tel:+919256810874" className="hover:text-pink-600"> +91-9116710874</a>
                                </p>
                            </li>
                            <li className="flex items-center gap-2">
                                <Mail className="w-5 h-5 text-gray-500" />
                                <p>
                                    <a href="mailto:info@thebestcab.in" className="hover:text-pink-600">info@thebestcab.in</a>
                                </p>
                            </li>
                            <li className="flex items-center gap-2">
                                <MapPin className="w-5 h-5 text-gray-500" />
                                <p className="hover:text-pink-600">Airport Terminal-2, Near Jawahar Circle, Jaipur</p>
                            </li>
                        </ul>
                    </div>
                    <div className="grid grid-cols-2 gap-8 sm:gap-6 sm:grid-cols-3">
                        <div>
                            <h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase">Useful Links</h2>
                            <ul className="text-gray-500 font-medium">
                                {["Jaipur", "Udaipur", "Agra", "Mumbai"].map((city, index) => (
                                    <li key={index} className="mb-4">
                                        <Link to="/packages" className="text-gray-400 hover:text-pink-600">
                                            {city} Tour Package
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div>
                            <h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase">Follow us</h2>
                            <ul className="text-gray-500 font-medium">
                                <li className="mb-4">
                                    <a href="/" className="hover:text-pink-600" aria-label="Instagram">Instagram</a>
                                </li>
                                <li>
                                    <a href="/" className="hover:text-pink-600" aria-label="Facebook">Facebook</a>
                                </li>
                                <li>
                                    <a href="/" className="hover:text-pink-600" aria-label="Facebook">Twitter</a>
                                </li>
                                <li>
                                    <a href="/" className="hover:text-pink-600" aria-label="Facebook">Youtube</a>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase">Legal</h2>
                            <ul className="text-gray-500 font-medium">
                                <li className="mb-4">
                                    <Link to="/privacy-policy" className="hover:text-pink-600">Privacy Policy</Link>
                                </li>
                                <li>
                                    <Link to="/terms-conditions" className="hover:text-pink-600">Terms & Conditions</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <hr className="my-6 border-gray-200 lg:my-8" />
                <div className="sm:flex sm:items-center sm:justify-between">
                    <span className="text-sm text-gray-500 sm:text-center">
                        © 2025 <Link to="/" className="hover:underline">The Best Cab™</Link>. All Rights Reserved.
                    </span>
                    <div className="flex mt-4 sm:justify-center sm:mt-0 space-x-5">
                        {[
                            { href: "/", icon: <FaInstagram />, label: "Instagram" },
                            { href: "/", icon: <FaLinkedin />, label: "LinkedIn" },
                            { href: "/", icon: <FaXTwitter />, label: "Twitter" },
                            { href: "/", icon: <FaYoutube />, label: "Youtube" },
                        ].map((item, index) => (
                            <a key={index} href={item.href} className="text-gray-500 hover:text-gray-900" aria-label={item.label}>
                                {item.icon}
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;